import { Dialog, Transition } from "@headlessui/react";
import axios from "axios";
import Cookies from "js-cookie";
import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { RxCross2 } from "react-icons/rx";
import { FaArrowLeft, FaChevronDown } from "react-icons/fa"; // Importing arrow icon
import AppContext from "../../context/AppContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import translations from "../../components/common/Translations";

import {saveBulkAssignTask, saveBulkAssignTaskByDept, saveBulkTask} from "../../service/Task";

import CommonButton from "../../components/common/CommonButton";
/*
  Code Developer Shivani Vaghani
 */
export default function BulkUploadModal({ setBulkUploadOpen, bulkUploadOpen, allowUpdateIfExists }) {
  const context = useContext(AppContext);
  const [fieldAgents, setFieldAgents] = useState([]);
  const [selectedAgents, setSelectedAgents] = useState([]);
  const [accountNumbers, setAccountNumbers] = useState([]);
  const [manualAccount, setManualAccount] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isCreateLoading, setIsCreateLoading] = useState(false);
  const [isCreateAssignLoading, setIsCreateAssignLoading] = useState(false);
  const dropdownRef = useRef(null);
  const cancelButtonRef = useRef(null);
  const navigate = useNavigate();
  const [inputFields, setInputFields] = useState({
    mandatory: [],
    nonMandatory: [],
  });
  const { theme,  langMode,  activityId, workflowName } = context;

  const handleGoBack = () => {
    const navigationPath =
      Cookies.get("viewmode") === "map" ? "/maptask" : "/task-manage";
    navigate(navigationPath);
    Cookies.remove("viewmode");
  };

  useEffect(() => {
    console.log("activity id: ", activityId)
    if (bulkUploadOpen && activityId) {
      const token = Cookies.get("accessToken");

      axios
        .get(
            `${process.env.REACT_APP_BASE_BACKEND_API_URL}api/v1/user/field-agents-by-workflow?workflowId=${activityId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((response) => {
          if (response.data.body.value)
            setFieldAgents(response.data.body.value);
        })
        .catch(console.error);
    }
  }, [bulkUploadOpen]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handlePasteExcel = (e) => {
    e.preventDefault();
    let values = e.clipboardData
      .getData("text")
      .split(/\r?\n|\t/)
      .map((line) => line.trim())
      .filter((line) => line !== "");
    setAccountNumbers((prev) => [...prev, ...values]);
  };

  const handleManualEntryKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (manualAccount.trim()) {
        setAccountNumbers((prev) => [...prev, manualAccount.trim()]);
        setManualAccount("");
      }
    }
  };

  const handleBulkAssignSaveTask = async () => {
    const deptId = localStorage.getItem("departmentId")?.replace(/"/g, "");
    if (
      accountNumbers === null &&
      workflowName === null &&
      activityId === null &&
      selectedAgents === null
    ) {
      toast.error(translations[langMode].noFieldsAvailable);
    } else {      
      const data = {
        accountNumbers,
        fieldAgentIds: selectedAgents,
        workflowId :activityId,
        workflowName,
        allowUpdateIfExists
      }
      try {
        setIsCreateAssignLoading(true)
        const response = await saveBulkAssignTaskByDept(data);
        setIsCreateAssignLoading(false)
        if (response === null) {
          toast.error("Error File Downloaded");
        } else if (response.header.code === 600) {
          toast.success("Tasks Created Successfully");
          handleGoBack();
        } else {
          toast.error(response.body.value);
        }
      } catch (error) {
        setIsCreateAssignLoading(false)
        console.error("Error in handleSaveTask:", error);
      }
    }
  };
  const handleBulkSaveTask = async () => {
    const deptId = localStorage.getItem("departmentId")?.replace(/"/g, "");
    if (
      accountNumbers === null &&
      selectedAgents === null &&
      workflowName === null &&
      activityId === null
    ) {
      toast.error(translations[langMode].noFieldsAvailable);
    } else {
      try {
        setIsCreateLoading(true)
        const data = {
          accountNumbers,
          fieldAgentIds: selectedAgents,
          workflowId :activityId,
          workflowName,
          allowUpdateIfExists
        }
        const response = await saveBulkTask(data);
        setIsCreateLoading(false)
        if (response === null) {
          toast.error("Error File Downloaded");
        } else if (response.header.code === 600) {
          toast.success("Tasks Created Successfully");
          handleGoBack();
        } else {
          toast.error(response.body.value);
        }
      } catch (error) {
        setIsCreateLoading(false)
        console.error("Error in handleSaveTask:", error);
      }
    }
  };

  return (
    <Transition.Root show={bulkUploadOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative"
        initialFocus={cancelButtonRef}
        onClose={setBulkUploadOpen}
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        <div className="fixed inset-0 w-screen overflow-y-auto ">
          <div
            onClick={handleGoBack}
            className={`p-2 rounded-full border cursor-pointer w-8 
            ${
              theme === "dark"
                ? "bg-gray-800 border-gray-600 hover:bg-gray-700"
                : ""
            }
            ${
              theme === "high-contrast"
                ? "high-contrast border border-gray-600"
                : ""
            }
            ${
              theme !== "dark" && theme !== "high-contrast"
                ? "border-gray-400 hover:bg-gray-200"
                : ""
            }`}
          >
            <FaArrowLeft
              className={`h-3 w-3 ${
                theme === "dark"
                  ? "text-white"
                  : theme === "high-contrast"
                  ? "text-black"
                  : "text-gray-700"
              }`}
            />
          </div>
          <div className="flex min-h-full items-center justify-center p-1">
            <Dialog.Panel className="w-full max-w-2xl bg-white rounded-lg shadow-xl p-4 pt-2">
              <div className="flex justify-between items-center pb-0">
                <h2 className="text-l font-extrabold">Bulk Upload</h2>
                <button
                  onClick={() => setBulkUploadOpen(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <RxCross2 />
                </button>
              </div>
              <div className="mt-3 space-y-4">
                <div className="border p-3 rounded-md bg-blue-50 h-32 overflow-y-auto">
                  {accountNumbers.map((num, index) => (
                    <span
                      key={index}
                      className="inline-flex items-center px-2 py-1 bg-gray-200 rounded mr-2 mb-2"
                    >
                      {num}
                      <button
                        onClick={() =>
                          setAccountNumbers((prev) =>
                            prev.filter((_, i) => i !== index)
                          )
                        }
                        className="ml-2 text-red-500"
                      >
                        x
                      </button>
                    </span>
                  ))}
                  <textarea
                    value={manualAccount}
                    onChange={(e) => setManualAccount(e.target.value)}
                    onKeyDown={handleManualEntryKeyDown}
                    onPaste={handlePasteExcel}
                    placeholder="Enter Account Number"
                    className="w-full border-none outline-none resize-none p-2 bg-blue-50"
                  />
                </div>
                <div className="flex justify-between items-center gap-3">
                  <div className="relative w-3/4">
                    <label className="text-sm font-extrabold block mb-1">
                      Assign To
                    </label>
                    <button
                      onClick={() => setIsOpen(!isOpen)}
                      className="w-full p-2 border rounded-md flex justify-between items-center bg-blue-50"
                    >
                      {selectedAgents.length > 0
                        ? `${selectedAgents.length} Agent(s) Selected`
                        : "Select Agents"}
                      <FaChevronDown
                        className={`ml-2 transition-transform ${
                          isOpen ? "rotate-180" : "rotate-0"
                        }`}
                      />
                    </button>
                    {isOpen && (
                      <div className="absolute left-0 mt-1 w-full bg-white shadow-lg border rounded-md z-50">
                        {fieldAgents.map((agent) => (
                          <label
                            key={agent.userId}
                            className="block p-2 hover:bg-gray-100 cursor-pointer"
                          >
                            <input
                              type="checkbox"
                              className="mr-2"
                              checked={selectedAgents.includes(agent.userId)}
                              onChange={() => {
                                setSelectedAgents(prev => prev.includes(agent.userId) ? prev.filter(id => id !== agent.userId) : [...prev, agent.userId]);
                              }}
                            />
                            {agent.name}
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="w-1/4 text-center">
                    <label className="text-sm font-extrabold block">
                      Total Count
                    </label>
                    <p className="p-2 bg-blue-50 border rounded-md">
                      {accountNumbers.length}
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-6 flex justify-center gap-2">
                {/* <button
                  className="px-4 py-2 bg-blue-600 text-white rounded-md"
                  onClick={handleBulkSaveTask}
                >
                  Create
                </button> */}

                <CommonButton onClick={handleBulkSaveTask} variant="primary" className={`${isCreateLoading ? "bg-opacity-60" : "bg-opacity-100"}`}>
                  {isCreateLoading ?  "Processing...":"Create"}
                </CommonButton>

                {/* <button
                  className="px-4 py-2 bg-green-600 text-white rounded-md"
                  onClick={handleBulkAssignSaveTask}
                >
                  Create and Assign
                </button> */}

                <CommonButton
                  onClick={handleBulkAssignSaveTask}
                  variant="success"
                  className={`${isCreateAssignLoading ? "bg-opacity-60" : "bg-opacity-100"}`}
                >
                   {isCreateAssignLoading ?  "Processing...":"Create and Assign"}
                </CommonButton>

                {/* <button
                  className="px-4 py-2 border rounded-md"
                  onClick={() => setBulkUploadOpen(false)}
                >
                  Cancel
                </button> */}

                <CommonButton
                  onClick={() => setBulkUploadOpen(false)}
                  variant="danger"
                >
                  Cancel
                </CommonButton>
              </div>
            </Dialog.Panel>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
